import React from "react";

const Mascot = () => {
  return (
    <div className="bg-white shadow-lg overflow-hidden h-full p-10">
      <div className="container mx-auto flex flex-col md:flex-row">
        <div className="flex-shrink-0 flex justify-center items-center">
          <img
            className="h-auto w-auto ml-10"
            src="/icikiwir.webp"
            alt="Character"
            style={{ maxHeight: "85vh" }} // Ensuring it doesn't exceed viewport height
          />
        </div>
        <div className="flex-grow flex flex-col justify-center items-center md:items-start">
          <div
            className="tracking-wide text-indigo-500 font-bold text-center md:text-left"
            style={{
              fontSize: "4.1vh",
              fontFamily: "'Playwrite FR Moderne'",
            }}
          >
            Ichikawa Watanabe
          </div>
          <p
            className="text-black text-center md:text-left"
            style={{
              fontSize: "2.5vh",
              textAlign: "justify",
              textJustify: "inter-word",
            }}
          >
            Ichika Watanabe, a name that captures the essence of a bustling
            river market, represents the convergence of communities and the flow
            of life.
          </p>
          <p
            className="text-gray-500 text-center md:text-left"
            style={{
              fontSize: "1.5vh",
              textAlign: "justify",
              textJustify: "inter-word",
            }}
          >
            The name Ichika is derived from "ichi" (市), meaning market, and
            "kawa" (川), meaning river or flow. Watanabe, on the other hand,
            translates to "crossing over a river," with "wata" (渡) meaning
            crossing and "nabe" (辺) meaning area or place. Together, Ichika
            Watanabe symbolizes a ferry crossing a lively river market, a place
            where people gather to socialize, trade, and immerse themselves in
            the vibrant atmosphere.
          </p>
          <a
            href="/#/mascot"
            className="mt-5 bg-indigo-500 hover:bg-indigo-600 text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline mx-auto block"
          >
            About her
          </a>
        </div>
      </div>
    </div>
  );
};

export default Mascot;
